<template>
    <b-modal v-model="modalShow" ref="modal-cancel" size="sm" title="Duplicação de propostas">
        <b-form novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group bmd-form-group is-filled" :class="{'has-danger' : validation.physical_proposal != ''}">

                        <label for="physical_proposal" class="bmd-label-floating">Novo Número do Contrato*</label>

                        <input type="text" autofocus="true" class="form-control" @input="form.physical_proposal = form.physical_proposal.replace(/\D/g, '')" name="physical_proposal" id="physical_proposal" v-model="form.physical_proposal"/>

                        <label v-if="validation.physical_proposal != ''" id="physical_proposal-error" class="error" for="physical_proposal">{{ validation.physical_proposal }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group bmd-form-group is-filled" :class="{'has-danger' : validation.quota != ''}">
                        <label for="quota" class="bmd-label-floating">Cota*</label>

                        <input type="text" class="form-control" @input="form.quota = form.quota.replace(/\D/g, '')" name="quota" id="quota" v-model="form.quota"/>

                        <label v-if="validation.quota != ''" id="quota-error" class="error" for="quota">{{ validation.quota }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group bmd-form-group is-filled"
                            v-bind:class="{'has-danger' : validation.group_id != ''}">
                        <label for="group_id" class="bmd-label-floating">Grupo</label>
                        <model-list-select 
                            class="form-control"
                            :list="groups"     
                            option-value="id"
                            option-text="name"
                            v-model="form.group_id">
                        </model-list-select>
                        <label v-if="validation.group_id != ''" id="group_id-error" class="error" for="group_id">{{ validation.group_id }}</label>
                    </div>
                </div>

            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitContemplate" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>
<script>
    import GroupService from '@/services/modules/groups.service';
    export default {
        data() {
            return {
                groups: [],
                form: {
                    id: 0,
                    physical_proposal: '',
                    quota: '',
                    group_id : '',
                },
                modalShow: true,
                validation: {
                    physical_proposal: '',
                    quota: '',
                    group_id : '',
                }
            };
        },
        mounted() {
            var self = this;

            self.form.id = self.$route.params.id;

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });

            if(self.$route.params.id)
                self.getDataGroups( self.$route.params.administrador_id );
        },
        methods: {
            async getDataGroups(_administratorId) {
                var self = this;

                self.$root.$emit("onLoading");

                const response = GroupService.getByAdministratorId(_administratorId);

                response.then(function (_groups) {
                    self.groups = _groups;
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            goBack() {
                var self = this;
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            onSubmitContemplate(_ev) {
                var self = this;
                var valid = true;

                self.validation = {
                    physical_proposal: '',
                    quota: ''
                };

                _ev.preventDefault();

                if (self.form.physical_proposal == '') {
                    self.validation.physical_proposal = "Campo obrigatório!";
                    valid = false;
                }

                if (self.form.quota == '') {
                    self.validation.quota = "Campo obrigatório!";
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit("onLoading");
                    const response = self.$store.dispatch('proposals/duplicateProposal', self.form);

                    response.then( res =>  {
                        self.$root.$emit("onLoading");
                        let options = {
                                html : true,
                                okText : 'Sim',
                                cancelText : 'Não',
                                customClass : 'customClass'
                        };

                        self.$dialog.confirm(`Nova proposta gerada com sucesso!<br /><br /><b>CONTRATO: ${res.physical_proposal}</b><br /> <b>COTA: ${res.quota}</b> <br /><br /> Você deseja abrir a nova proposta agora?`, options)
                                    .then(() => {
                                        // self.$router.push(`/proposals/${res.id}`);
                                        self.$router.push({'name': 'proposals.show', params: {'id': res.id}});
                                    })
                                    .catch(() => {});

                        self.goBack();
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                    });
                }
            }
        }
    };
</script>

<style scoped>
    .customClass{
        width: 90%;
    }
</style>